export default "__VITE_ASSET__BkQqnrBU__"